import NutakuService from "./NutakuService";

type Box = {
    id: number;
    price: number | string;
    reward_gems: number;
    first_payment?: boolean;
};

const buildPaymentData = (box: Box) => {
    const reward = box.first_payment && box.id !== 4
        ? box.reward_gems * 2
        : box.reward_gems;

    const name = `${reward} Gems`;
    const image = `https://nutaku.depraved.world/img/nutaku/${box.id}.png`;

    return { name, image };
};

export const NutakuPaymentBrowserService = {
    startAndroid(box: Box) {
        const { name, image } = buildPaymentData(box);

        return NutakuService.buyItem({
            id: box.id,
            sku: box.id,
            name,
            price: box.price,
            image,
        });
    },

    async start(box: Box) {
        const nutaku = (window as any).NutakuGI;
        const { name, image } = buildPaymentData(box);

        Object.assign(nutaku.paymentObject, {
            price: box.price,
            name,
            skuId: box.id,
            imgUrl: image,
            description: name,
        });

        try {
            const payment = await nutaku.createPayment(nutaku.paymentObject);

            if (payment?.error) {
                console.log(payment.error);
                return { status: "error", error: payment.error };
            }

            console.log("Payment status:", payment?.status, "paymentId:", payment?.paymentId);
            return payment;
        } catch (e) {
            console.log("createPayment exception:", e);
            return { status: "error", error: e };
        }
    },
};